import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import ModelDetails from '~/components/ModelDetails';
import { Image3D } from '~/domain/patient/image3d';
import { transform3DImageData } from '~/utils/transforms/imageDataTransforms';

type ImageDetailsProps = {
    image: Image3D;
};

export default function ImageDetails({ image }: ImageDetailsProps) {
    const { modality, length, series, imageType, generationModel } =
        transform3DImageData(image);
    const hasSeriesDescription = series.description !== '';

    return (
        <Box width="100%" display="flex" flexDirection="column" gap={0}>
            <Box>
                <Box
                    display="flex"
                    gap={1}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Box display="flex" gap={0.5} alignItems="end">
                        <Typography>{modality}</Typography>
                        <Typography
                            color="primary"
                            fontSize={12}
                            lineHeight={1.8}
                        >
                            ({length})
                        </Typography>
                    </Box>

                    <Box>
                        <Typography fontSize={10} variant="body2">
                            {series?.date?.toDateString()}
                        </Typography>
                    </Box>
                </Box>
                <Box position="relative">
                    <Typography
                        fontSize={12}
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {imageType.join(', ')}
                    </Typography>
                </Box>
                <Box position="relative">
                    <Typography
                        fontSize={12}
                        fontStyle={hasSeriesDescription ? 'normal' : 'italic'}
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {hasSeriesDescription
                            ? series.description
                            : 'No series description'}
                    </Typography>
                </Box>
                <ModelDetails generationModel={generationModel} />
            </Box>
        </Box>
    );
}
